(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["programme-tabs"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const tagName = 'moreira-programme-v3';
  if (!window.customElements || customElements.get(tagName)) return;

  class MoreiraProgramme extends HTMLElement {
    connectedCallback() {
      // L'initialisation différée laisse au navigateur le temps de lire les enfants.
      this._frame = requestAnimationFrame(() => this._init());
    }

    _init() {
      if (!this.isConnected || this._ready) return;
      this._ready = true;
      this._controller = new AbortController();
      this._animations = new Set();
      this._steps = Array.from(this.querySelectorAll('[data-mp-step]'));
      this._reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._printing = false;
      const signal = this._controller.signal;

      this.addEventListener('click', (event) => this._onClick(event), { signal });
      this.addEventListener('shopify:block:select', (event) => this._onBlockSelect(event), { signal });
      this._steps.forEach((step) => {
        step.addEventListener('toggle', () => {
          this._syncButtons();
          if (step.open && this._canAnimate()) {
            const panel = step.querySelector('[data-mp-panel]');
            this._animate(panel, [
              { opacity: .45, transform: 'translateY(7px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ], { duration: 260, easing: 'ease-out' });
          }
        }, { signal });
      });

      const tools = this.querySelector('[data-mp-tools]');
      if (tools) tools.hidden = false;
      this._syncButtons();

      // Pas de contenu caché en CSS : le programme reste lisible sans JavaScript.
      if ('IntersectionObserver' in window && this._canAnimate()) {
        this._observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this._observer.unobserve(entry.target);
            if (this._canAnimate()) {
              this._animate(entry.target, [
                { opacity: .55, transform: 'translateY(14px)' },
                { opacity: 1, transform: 'translateY(0)' }
              ], { duration: 450, easing: 'cubic-bezier(.2,.65,.3,1)' });
            }
          });
        }, { threshold: .06 });
        this.querySelectorAll('[data-mp-reveal]').forEach((node) => this._observer.observe(node));
      }

      this._reduced.addEventListener('change', () => {
        if (this._reduced.matches) this._cancelAnimations();
      }, { signal });

      window.addEventListener('beforeprint', () => {
        if (this._printState) return;
        this._printing = true;
        this._printState = this._steps.map((step) => step.open);
        this._cancelAnimations();
        this._steps.forEach((step) => { step.open = true; });
      }, { signal });
      window.addEventListener('afterprint', () => {
        if (!this._printState) return;
        this._steps.forEach((step, index) => { step.open = this._printState[index]; });
        this._printState = null;
        this._printing = false;
        this._syncButtons();
      }, { signal });
    }

    _canAnimate() {
      return this.dataset.animations === 'true'
        && !this._reduced.matches
        && !this._printing
        && !(window.Shopify && window.Shopify.designMode)
        && typeof this.animate === 'function';
    }

    _animate(node, frames, options) {
      if (!node) return;
      const animation = node.animate(frames, options);
      this._animations.add(animation);
      animation.finished.then(
        () => this._animations.delete(animation),
        () => this._animations.delete(animation)
      );
    }

    _cancelAnimations() {
      if (!this._animations) return;
      this._animations.forEach((animation) => animation.cancel());
      this._animations.clear();
    }

    _closeOthers(current) {
      if (this.dataset.multiple === 'true') return;
      this._steps.forEach((step) => {
        if (step !== current) step.open = false;
      });
    }

    _onClick(event) {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('[data-mp-action]');
      if (button && this.contains(button)) {
        const expand = button.dataset.mpAction === 'expand';
        // « Tout ouvrir » constitue une action explicite, même en mode une étape.
        this._steps.forEach((step) => { step.open = expand; });
        this._syncButtons();
        const status = this.querySelector('[data-mp-status]');
        if (status) status.textContent = expand
          ? 'Toutes les étapes du programme sont ouvertes.'
          : 'Toutes les étapes du programme sont fermées.';
        return;
      }
      const summary = event.target.closest('.mp-summary');
      if (!summary || !this.contains(summary)) return;
      const step = summary.parentElement;
      if (!step.open) this._closeOthers(step);
      // Le navigateur gère l'ouverture, le clic, Entrée et Espace nativement.
    }

    _onBlockSelect(event) {
      if (!(event.target instanceof Element)) return;
      const step = event.target.closest('[data-mp-step]');
      if (!step || !this.contains(step)) return;
      this._closeOthers(step);
      step.open = true;
      this._syncButtons();
      this._cancelAnimations();
    }

    _syncButtons() {
      const total = this._steps.length;
      const opened = this._steps.filter((step) => step.open).length;
      const expand = this.querySelector('[data-mp-action="expand"]');
      const collapse = this.querySelector('[data-mp-action="collapse"]');
      if (expand) expand.disabled = total === 0 || opened === total;
      if (collapse) collapse.disabled = opened === 0;
    }

    disconnectedCallback() {
      cancelAnimationFrame(this._frame);
      if (this._controller) this._controller.abort();
      if (this._observer) this._observer.disconnect();
      this._cancelAnimations();
      this._ready = false;
      this._printState = null;
    }
  }

  customElements.define(tagName, MoreiraProgramme);
})();

  } catch(e) { console.error(e); }
})();
})();
